import { render } from "./NumberControl.vue?vue&type=template&id=a01b7456&ts=true"
import script from "./NumberControl.vue?vue&type=script&lang=ts"
export * from "./NumberControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__